export const OrderActions = {
  ADDON_ADD: "ADDON_ADD",
  PRODUCT_ADD: "PRODUCT_ADD",
  CALCULATE: "CALCULATE",
  REMOVE_PRODUCT_ITEM: "REMOVE_PRODUCT_ITEM",
  DELETE_PRODUCT_ID: "DELETE_PRODUCT_ID",
  INCRESS_PRODUCT_QTY: "INCRESS_PRODUCT_QTY",
  DECRESS_PRODUCT_QTY: "DECRESS_PRODUCT_QTY",
  SET_DISSCOUNT_DETAILS: "SET_DISSCOUNT_DETAILS",
  CLEAR_DELIVERY_DATA: "CLEAR_DELIVERY_DATA",
  RESET: "RESET",
  DUPLICATE_ORDER: "DUPLICATE_ORDER",
  REPLACE_ORDER: "REPLACE_ORDER",
};
